/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'rating-smiley-2': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_rating-smiley-2_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_rating-smiley-2_a)"><g transform="translate(-510.06 -486.329)" _fill="none" _stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"><circle pid="1" cx="21.25" cy="21.25" r="21.25" transform="translate(510.81 487.079)"/><circle pid="2" cx="3.196" cy="3.196" r="3.196" transform="translate(524.544 500.019)"/><circle pid="3" cx="3.196" cy="3.196" r="3.196" transform="translate(533.494 500.019)"/><path pid="4" d="M530.937 502.576h2.557M539.247 502.576h12.785M511.12 502.576h14.064M519.442 514.722h25.57"/></g></g>`
  }
})
/* tslint:enable */
